import { render, staticRenderFns } from "./VideoBanner.vue?vue&type=template&id=e0735800&scoped=true&"
import script from "./VideoBanner.vue?vue&type=script&lang=ts&"
export * from "./VideoBanner.vue?vue&type=script&lang=ts&"
import style0 from "./VideoBanner.vue?vue&type=style&index=0&id=e0735800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0735800",
  null
  
)

export default component.exports